import { Component } from '@angular/core';

@Component({
    selector: 'app-header-actions',
    templateUrl: './header-actions.component.html',
    styleUrls: ['./header-actions.component.css'],
    standalone: false
})
export class HeaderActionsComponent {
  constructor() {}
}
